import { css as o, keyframes as t } from "styled-components";
import "../Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getPaletteForeground as a, getPaletteBackground as n, getPaletteText as e, getSpacings as r } from "../Theme/utils.es.js";
import "react";
import "../../jsx-runtime-C5mzlN2N.js";
import "../../CssBaseline-Bp4jdUgb.js";
const g = {
  root: o`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    gap: 8px;

    padding: ${r("md")} ${r("lg")};
    cursor: pointer;

    border: none;
    border-radius: 6px;

    color: ${a("quaternary.default")};
    background-color: ${n("primary.default")};

    text-decoration: none;

    span {
      color: ${e("secondary.default")};
    }
  `,
  active: o`
    color: ${a("quaternary.hover")};
    background-color: ${n("primary.hover")};

    span {
      color: ${e("secondary.hover")};
    }
  `
}, i = {
  open: t`
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  `,
  close: t`
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  `
}, y = o`
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 150ms;

  &[data-is-open='true'] {
    animation-name: ${i.open};
  }
  
  &[data-is-open='false'] {
    animation-name: ${i.close};
  }
`, s = {
  open: t`
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(0);
    }
  `,
  close: t`
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  `
}, $ = o`
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 150ms;

  &[data-is-open='true'] {
    animation-name: ${s.open};
  }

  &[data-is-open='false'] {
    animation-name: ${s.close};
  }
`;
export {
  y as backdropAnimationStyles,
  $ as contentAnimationStyles,
  g as sideBarItemStyles
};
